/* ------------------------  用户相关  ------------------------ */

// 检验登录状态
export const CHECKOUT_LOGIN_STATUS = 'CHECKOUT_LOGIN_STATUS'
// 退出登录
export const USER_LOGOUT = 'USER_LOGOUT'
// 加载个人信息
export const LOAD_PROFILE = 'profile/LOAD_PROFILE'

/* ------------------------  杂项  ------------------------ */

// 改变 Loading 状态
export const TOGGLE_LOADING_STATUS = 'TOGGLE_LOADING_STATUS'

// 改变 Loading 状态
export const TOGGLE_LOADING_STATUS_LOGIN = 'TOGGLE_LOADING_STATUS_LOGIN'

/* ------------------------  商品相关  ------------------------ */

// 加载商品
export const LOAD_PRODUCT = 'product/LOAD_PRODUCT'
export const LOAD_PRODUCT_LIST = 'product/LOAD_PRODUC_TLIST'
export const LOAD_PRODUCT_RATING = 'product/LOAD_PRODUCT_RATING'
// 获取商品列表当前页数
export const STORE_PRODUCT_CURRENTPAGE = 'product/STORE_PRODUCT_CURRENTPAGE'
// 获取商品列表总数
export const STORE_PRODUCT_TOTAL = 'product/STORE_PRODUCT_TOTAL'
export const DELETE_PRODUCT = 'product/DELETE_PRODUCT'
export const STORE_ADD_PRODUCT = 'product/STORE_ADD_PRODUCT'
export const STORE_EDIT_PRODUCT = 'product/STORE_EDIT_PRODUCT'

/* ------------------------------------------------------------------------ */

/* ------------------------  品牌相关  ------------------------ */

// 加载 品牌
export const LOAD_BRAND = 'brand/LOAD_BRAND'
export const LOAD_BRAND_LIST = 'brand/LOAD_BRAND_LIST'
export const LOAD_BRAND_RATING = 'brand/LOAD_BRAND_RATING'
// 获取品牌列表当前页数
export const STORE_BRAND_CURRENTPAGE = 'brand/STORE_BRAND_CURRENTPAGE'
// 获取品牌列表总数
export const STORE_BRAND_TOTAL = 'brand/STORE_BRAND_TOTAL'
export const DELETE_BRAND = 'brand/DELETE_BRAND'
export const STORE_ADD_BRAND = 'brand/STORE_ADD_BRAND'
export const STORE_EDIT_BRAND = 'brand/STORE_EDIT_BRAND'

/* ------------------------------------------------------------------------ */

/* ------------------------  单位相关  ------------------------ */

// 加载  单位
export const LOAD_UNIT = 'unit/LOAD_UNIT'
export const LOAD_UNIT_LIST = 'unit/LOAD_UNIT_LIST'
export const LOAD_UNIT_RATING = 'unit/LOAD_UNIT_RATING'
// 获取列表当前页数
export const STORE_UNIT_CURRENTPAGE = 'unit/STORE_UNIT_CURRENTPAGE'
// 获取列表总数
export const STORE_UNIT_TOTAL = 'unit/STORE_UNIT_TOTAL'
export const DELETE_UNIT = 'unit/DELETE_UNIT'
export const STORE_ADD_UNIT = 'unit/STORE_ADD_UNIT'
export const STORE_EDIT_UNIT = 'unit/STORE_EDIT_UNIT'

/* ------------------------------------------------------------------------ */

/* ------------------------  属性相关  ------------------------ */

export const LOAD_PROPERTY = 'property/LOAD_PROPERTY'
export const LOAD_PROPERTY_LIST = 'property/LOAD_PROPERTY_LIST'
export const LOAD_PROPERTY_RATING = 'property/LOAD_PROPERTY_RATING'
// 获取列表当前页数
export const STORE_PROPERTY_CURRENTPAGE = 'property/STORE_PROPERTY_CURRENTPAGE'
// 获取列表总数
export const STORE_PROPERTY_TOTAL = 'property/STORE_PROPERTY_TOTAL'
export const DELETE_PROPERTY = 'property/DELETE_PROPERTY'
export const STORE_ADD_PROPERTY = 'property/STORE_ADD_PROPERTY'
export const STORE_EDIT_PROPERTY = 'property/STORE_EDIT_PROPERTY'

/* ------------------------------------------------------------------------ */

/* ------------------------  订单相关  ------------------------ */

export const LOAD_ORDER_DETAIL = 'order/LOAD_ORDER_DETAIL'
export const LOAD_ORDER_LIST = 'order/LOAD_ORDER_LIST'
export const LOAD_ORDER_RATING = 'order/LOAD_ORDER_RATING'
// 获取列表当前页数
export const STORE_ORDER_CURRENTPAGE = 'order/STORE_ORDER_CURRENTPAGE'
// 获取列表总数
export const STORE_ORDER_TOTAL = 'order/STORE_ORDER_TOTAL'
export const STORE_ORDER_STATUS = 'order/STORE_ORDER_STATUS'

/* ------------------------------------------------------------------------ */

/* ------------------------  购物车  ------------------------ */
export const INIT_BUYCART = 'INIT_BUYCART'
export const ADD_CART = 'ADD_CART'
export const GET_USERINFO = 'GET_USERINFO'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const ADD_ANIMATION = 'ADD_ANIMATION'
export const SHOW_CART = 'SHOW_CART'
export const REDUCE_CART = 'REDUCE_CART'
export const EDIT_CART = 'EDIT_CART'
/* ------------------------------------------------------------------------ */

/* ------------------------  商品  ------------------------ */

export const LOAD_GOODS_LIST = 'order/LOAD_GOODS_LIST'
export const STORE_GOODS_TOTAL = 'order/STORE_GOODS_TOTAL'
/* ------------------------------------------------------------------------ */







// WEBPACK FOOTER //
// ./src/store/mutation-types.js